import { configurationContainer } from "@/configurationContainer";

export const projectPageUrl =
    ({ databaseIds, currency }: { databaseIds: number[]; currency?: string }) =>
    (projectId: number) => {
        const params = new URLSearchParams();
        databaseIds.forEach(databaseId => {
            params.append("setDb", databaseId.toString());
        });
        if (currency !== undefined) {
            params.append("currency", currency);
        }
        return `${configurationContainer.PUBLIC_PRODA_URL}/rr/reports/project/${projectId}/rentRoll?${params.toString()}`;
    };
